import { fail, success } from '@/helpers/result-helper'
import toasts from '@/services/toasts/index'
import { VuexResponse } from '@/helpers/vuex-action-builder'

const getDefaultState = () => {
  return {
    loadingSsoCount: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    isLoadingSso: (state) => state.loadingSsoCount > 0,
  },
  mutations: {
    START_LOADING_SSO(state) {
      state.loadingSsoCount++
    },
    FINISH_LOADING_SSO(state) {
      state.loadingSsoCount--
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    /**
     * @param {*} param0
     * @param {Number} fileId
     * @returns {Object} object with 'url' property
     */
    async getSsoUrl({ commit, dispatch }) {
      const result = await new VuexResponse(commit, dispatch)
        .request(() => this.$api.docebo.getSsoUrl())
        .withLoading('START_LOADING_SSO', 'FINISH_LOADING_SSO')
        .withStatusCode()
        .go()

      if (!result?.isSuccess)
        return await dispatch('handleDoceboError', {
          error: result,
        })
      return success({ data: result.data })
    },
    /**
     * Map errors into a structured object to inform UI about any required
     * state changes
     * (26/08/25) There is only one error at this time
     *
     * @param {{commit: Function, dispatch: Function}} vuexContext
     * @param {{error: ResultDTO<ErrorResponseDTO>}} payload
     * @returns {ResultDTO}
     */
    handleDoceboError(vuexContext, { error }) {
      toasts.error(this.$i18n.t('growthHub.api.genericErrorText'))

      return fail()
    },
  },
}
